module.exports = __webpack_public_path__ + "static/img/pic_rjyf_rjfw_zx_pre.db134c15.png";